import hexToRgba from 'hex-rgba';
import colors from './colors';
var black = colors.black,
    gray = colors.gray,
    white = colors.white,
    negative = colors.negative,
    accent = colors.accent,
    dark = colors.dark;
var darkPalette = {
  background: {
    neutral: {
      primary: '#27272B',
      secondary: '#2D2C30',
      tertiary: '#1F1F21',
      popover: '#2D2C30',
      primaryTransparent: 'rgba(40, 39, 43, 0.56)',
      tertiaryTransparent: 'rgba(31, 31, 33, 0.56)',
      dialogOverlay: 'rgba(0, 0, 0, 0.56)'
    },
    semantic: {
      warning: '#473C24',
      accent: '#45312C',
      positive: '#2C3633',
      negative: '#472E31',
      positiveGradient: 'linear-gradient(180deg, #202024 0%, #232A2B 50%, #253835 100%)',
      negativeGradient: 'linear-gradient(180deg, #241F23 0%, #30272A 50.99%, #472D30 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #27272B 3.5%, rgba(39, 39, 43, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #2D2C30 3.5%, rgba(45, 44, 48, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #1F1F21 3.5%, rgba(31, 31, 33, 0) 96.51%)'
    }
  },
  label: {
    accent: '#FF7C47',
    accentHigh: '#FF9064',
    accentHighest: '#FF9E77',
    primary: '#E7E6EB',
    secondary: '#A6A3AD',
    secondaryHigh: '#D2D1D7',
    tertiary: '#817E87',
    tertiaryHigh: '#97959E',
    placeholder: '#65646B',
    inactive: 'rgba(154, 151, 161, 0.4)',
    positive: '#45BA8D',
    negative: '#FF6164',
    warning: '#F7CC1E',
    inverse: '#0A0A0A',
    primaryActive: '#FF7C47',
    secondaryActive: '#D2D1D7',
    tertiaryActive: '#97959E',
    plaseholder: '#65646B'
  },
  fill: {
    primary: {
      highest: '#FF8D5C',
      high: '#FF7C47',
      mid: '#E06D3F',
      low: '#B05733',
      muted: '#804128',
      overlay32: 'rgba(176, 86, 49, 0.32)',
      overlay24: 'rgba(176, 86, 49, 0.24)',
      overlay16: 'rgba(176, 86, 49, 0.16)',
      overlay8: 'rgba(176, 86, 49, 0.08)'
    },
    secondary: {
      highest: '#E0DFE5',
      high: '#A3A2A8',
      mid: '#7B7980',
      low: '#555359',
      muted: '#3F3E42',
      overlay32: 'rgba(86, 85, 92, 0.32)',
      overlay24: 'rgba(86, 85, 92, 0.24)',
      overlay16: 'rgba(86, 85, 92, 0.16)',
      overlay8: 'rgba(86, 85, 92, 0.08)'
    },
    positive: {
      highest: '#68D4A5',
      high: '#45BA8D',
      mid: '#288F6B',
      low: '#2D735B',
      muted: '#305C4F',
      overlay32: 'rgba(45, 115, 91, 0.32)',
      overlay24: 'rgba(45, 115, 91, 0.24)',
      overlay16: 'rgba(45, 115, 91, 0.16)',
      overlay8: 'rgba(45, 115, 91, 0.08)'
    },
    negative: {
      highest: '#FF8082',
      high: '#FF6164',
      mid: '#E84144',
      low: '#BD393D',
      muted: '#823436',
      overlay32: 'rgba(189, 57, 61, 0.32)',
      overlay24: 'rgba(189, 57, 61, 0.24)',
      overlay16: 'rgba(189, 57, 61, 0.16)',
      overlay8: 'rgba(189, 57, 61, 0.08)'
    },
    note: {
      highest: '#FCD356',
      high: '#FAC832',
      mid: '#EDAF11',
      low: '#BF8C14',
      muted: '#916A11',
      overlay32: 'rgba(191, 140, 20, 0.32)',
      overlay24: 'rgba(191, 140, 20, 0.24)',
      overlay16: 'rgba(191, 140, 20, 0.16)',
      overlay8: 'rgba(191, 140, 20, 0.08)'
    }
  },
  divider: {
    primary: '#161517',
    secondary: '#1E1E21',
    tertiary: '#09090A',
    altPrimary: '#4A494F',
    altSecondary: '#343338'
  },
  static: {
    backgroundPrimary: '#27272B',
    black: '#0A0A0A',
    blackAlfa72: 'rgba(10, 10, 10, 0.72)',
    blackAlfa56: 'rgba(10, 10, 10, 0.56)',
    blackAlfa24: 'rgba(10, 10, 10, 0.24)',
    blackAlfa16: 'rgba(10, 10, 10, 0.16)',
    blackAlfa8: 'rgba(10, 10, 10, 0.08)',
    blackAlfa4: 'rgba(10, 10, 10, 0.04)',
    white: '#FFFFFF',
    whiteAlfa72: 'rgba(255, 255, 255, 0.72)',
    whiteAlfa56: 'rgba(255, 255, 255, 0.56)',
    whiteAlfa24: 'rgba(255, 255, 255, 0.24)',
    whiteAlfa16: 'rgba(255, 255, 255, 0.16)',
    whiteAlfa8: 'rgba(255, 255, 255, 0.08)',
    whiteAlfa4: 'rgba(255, 255, 255, 0.04)',
    primary: '#FF7C47',
    primaryAlfa32: 'rgba(224, 109, 63, 0.32)',
    secondary: '#A6A3AD',
    secondaryAlfa32: 'rgba(166, 163, 173, 0.32)',
    positive: '#4BBF93',
    negative: '#FF6B6E',
    note: '#FFCB30'
  },
  shadow: {
    button: '0px 1px 3px rgba(0, 0, 0, 0.6)',
    accent: '0px 3px 6px -2px rgba(86, 36, 16, 0.38), 0px 6px 12px rgba(88, 40, 24, 0.27), 0px 8px 16px rgba(0, 0, 0, 0.6)',
    popover: '0px 4px 16px rgba(0, 0, 0, 0.7), 0px 16px 40px rgba(0, 0, 0, 0.32)',
    dialog: '0px 12px 16px rgba(0, 0, 0, 0.32), 0px 24px 56px rgba(0, 0, 0, 0.56)',
    cardEasy: '0px 6px 16px rgba(0, 0, 0, 0.2)',
    cardHeavy: '0px 1px 4px rgba(0, 0, 0, 0.2), 0px 6px 16px rgba(0, 0, 0, 0.4)',
    headerWeb: '0px 1px 4px rgba(0, 0, 0, 0.4), 0px 6px 16px rgba(0, 0, 0, 0.4)'
  },
  base: {
    accent: accent['1'],
    error: negative['2'],
    disabled: black['3']
  },
  input: {
    main: {
      text: white['2'],
      background: hexToRgba(gray['2'], 8),
      backgroundDisabled: hexToRgba(gray['2'], 4),
      backgroundHover: hexToRgba(gray['2'], 16),
      backgroundError: hexToRgba(negative['2'], 8),
      border: black['3'],
      borderDisabled: hexToRgba(black['3'], 56),
      borderHover: gray['1'],
      borderError: negative['2']
    },
    label: gray['2'],
    message: gray['2']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['2'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(white['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: black['2'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: white['2'],
    secondary: gray['2']
  },
  paper: {
    background: black['2'],
    shadow: {
      elevation1: '0px 1px 6px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12)',
      elevation2: '0px 3px 10px rgba(0, 0, 0, 0.23), 0px 3px 10px rgba(0, 0, 0, 0.16)',
      elevation3: '0px 10px 18px rgba(0, 0, 0, 0.22), 0px 14px 45px rgba(0, 0, 0, 0.25)'
    }
  },
  modal: {
    backdrop: hexToRgba(black['0'], 50)
  },
  dialog: {
    background: black['2']
  },
  dropDown: {
    background: dark['1']
  },
  dividerLegacy: {
    primary: dark['5'],
    secondary: dark['2']
  },
  switch: {
    icon: gray['3'],
    shadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(black['1'], 56),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: black['0'],
    backgroundSecondary: black['1']
  },
  snackbar: {
    text: black['1'],
    background: white['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
};
export default darkPalette;